import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { NotificationResponse } from "src/app/shared/models/notification-response.model";
import { UnreadCountResponse } from "src/app/shared/models/unread-count-response.model";
import { environment } from "src/environment/environment";

@Injectable({
  providedIn: 'root'
})
export class NotificationApiService {
  private readonly baseUrl = `${environment.apiUrl}/notifications`;
  private readonly backgroundRequestHeaders = {
    "X-Skip-Loader": "true",
    "X-Background-Request": "true",
  };

  constructor(private http: HttpClient) {}

  getNotifications(params?: {
    unreadOnly?: boolean;
    type?: string;
    page?: number;
    size?: number;
  }) {
    return this.http.get<any>(this.baseUrl, {
      params: params as any,
      headers: this.backgroundRequestHeaders,
    });
  }

  getUnreadCount() {
    return this.http.get<UnreadCountResponse>(`${this.baseUrl}/unread-count`, {
      headers: this.backgroundRequestHeaders,
    });
  }

  markAsRead(id: number) {
    return this.http.patch<NotificationResponse>(`${this.baseUrl}/${id}/read`, {}, {
      headers: this.backgroundRequestHeaders,
    });
  }

  markAllAsRead() {
    return this.http.patch<any>(`${this.baseUrl}/read-all`, {}, {
      headers: this.backgroundRequestHeaders,
    });
  }

  deleteNotification(id: number) {
    return this.http.delete<void>(`${this.baseUrl}/${id}`, {
      headers: this.backgroundRequestHeaders,
    });
  }
}
